<script>
  import { domainName, record, newRecordCreated } from '../stores.js';
  import DKIMSearch from './dkimSearch.svelte';
  import DKIMResult from './dkimResult.svelte';
  import Tools from '../Tools.svelte';
</script>

<svelte:head>
  <script src="//info.agari.com/js/forms2/js/forms2.min.js"></script>
</svelte:head>

{#if $domainName == '' }
  <DKIMSearch />
  <Tools skip={'dkim'} />
{:else}
  <DKIMResult />
{/if}

<style>

</style>
